export default __webpack_public_path__ + "static/media/slide3_m_bg.b3efbded.png";